<template>
  <div class="index">
    <div class="index-con">
      <el-carousel class="swiper index-swiper">
        <el-carousel-item class="swiper-item" v-for="item in [1, 2, 3, 4]" :key="item">
          <img class="swiper-item-img" :src="'./static/swiper' + item + '.jpg'" alt="" />
          <p>
            MAIQS 2026<br>
            International Conference on Measurement, AI, Quality and Sustainability<br>
            Transforming Industry and Society with Advanced Control, Robotics and Embodied Intelligence<br>
            14–16 December 2026, Hangzhou, China
          </p>
        </el-carousel-item>
      </el-carousel>
      <div class="news-con">
        <div class="news">
          <div class="news-list-2">
            <div class="news-title bg-green">
              <i class="el-icon-document"></i>
              <div v-html="$t('indexTitle1')"></div>
            </div>
            <div class="news-cons">
              <div v-html="$t('indexText1')" class="news-text"></div>
            </div>
          </div>
          <div class="news-list-2">
            <div class="news-title bg-green">
              <i class="el-icon-document"></i>
              <div v-html="$t('indexText2Title')"></div>
            </div>
            <div class="news-cons">
              <div v-html="$t('indexText2Text')" class="news-text"></div>
            </div>
          </div>
          <div class="news-list-2">
            <div class="sb-title dsb bg-green">
              <img src="../../static/naozhong_left.png" alt="" />
              <p>{{ $t("indexTitle2") }}</p>

            </div>
            <div class="login-lists news-cons one-bg-gray">
              <div class="login-list mb-4 login-d-flex" v-for="(item, index) in $t('indexdateList')"
                :key="index + 'as'">
                <p class="text-justify">
                  {{ item.text }}:
                  <span v-if="item.oldDate" style="text-decoration: line-through; margin-right: 8px;" v-html="formatDate(item.oldDate)"></span><span v-html="formatDate(item.date)"></span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="news">
          <div class="news-list-1">
            <div>
              <div class="sb-title bg-green">
                <img src="../../static/lamp_left.png" alt="" />
                <p>{{ $t("indexText15") }}</p>
                <img src="../../static/lamp_right.png" alt="" />
              </div>
            </div>
            <div class="login-lists measurement-con">
              <div>
                <div class="login-list">
                  <b>
                    Measurement:
                  </b>
                </div>
                <div class="login-list measure-list"><span>*</span>Digital Calibration, Dynamic Standards and
                  Traceability
                </div>
                <div class="login-list measure-list"><span>*</span> Measurement Theory, Errors and Uncertainty</div>
                <div class="login-list measure-list"><span>*</span> Metrology and Signal Processing for Industry 4.0,
                  IoT and Digital Twins</div>
                <div class="login-list measure-list"><span>*</span> Intelligent Sensors and Quantum Imaging</div>
              </div>
              <div>
                <div class="login-list">
                  <b>
                    Artificial Intelligence:
                  </b>
                </div>
                <div class="login-list measure-list"><span>*</span> Machine Learning and Deep Learning</div>
                <div class="login-list measure-list"><span>*</span> Embodied AI, Robotics and Autonomous Systems,
                  Collaborative Robots, Mobile Robots, Humanoid Robots</div>
                <div class="login-list measure-list"><span>*</span> Explainable AI, Trustworthy AI and AI
                  Standardisation</div>
                <div class="login-list measure-list"><span>*</span> Natural Language Processing (NLP), Large Language
                  Models (LLMs) and Future AI Directions</div>
              </div>
              <div>
                <div class="login-list">
                  <b>
                    Quality:
                  </b>
                </div>
                <div class="login-list measure-list"><span>*</span> AI-driven QFD, Inclusive Design, and TRIZ for
                  Innovation
                </div>
                <div class="login-list measure-list"><span>*</span> Statistical Process Control, Six Sigma, Lean 4.0
                  and Quality 4.0
                </div>
                <div class="login-list measure-list"><span>*</span> Testing, Product Verifications and Conformity
                  Assessment
                </div>
                <div class="login-list measure-list"><span>*</span> Safety, Reliability, NDT/NDE, Risk Management,
                  Maintenance and Asset Management
                </div>
              </div>
              <div>
                <div class="login-list">
                  <b>
                    Sustainability:
                  </b>
                </div>
                <div class="login-list measure-list"><span>*</span> Sustainable Technologies and Innovations for
                  Industries
                </div>
                <div class="login-list measure-list"><span>*</span> AI-enabled Energy Efficiency 4.0 and Sector Coupling
                </div>
                <div class="login-list measure-list"><span>*</span> Dynamic LCA, Digital Product Passports, and Scope 3
                  Emissions</div>
                <div class="login-list measure-list"><span>*</span> Regenerative Economy, Urban Mining, and Critical
                  Raw Materials Recovery</div>
                <div class="login-list measure-list"><span>*</span> Tipping Points, Climate Change and Sustainability
                </div>
              </div>
              <div>
                <div class="login-list">
                  <b>
                    Cross-disciplinary:
                  </b>
                </div>
                <div class="login-list measure-list"><span>*</span> HCI, Human-AI Collaboration in Smart Systems,
                  AR/VR/MR, Digital Human and Spatial Intelligence</div>
                <div class="login-list measure-list"><span>*</span> Multimodal Information System and Multimodal AI
                </div>
                <div class="login-list measure-list"><span>*</span> Industrial Networks and Future Communication
                  Technologies</div>
                <div class="login-list measure-list"><span>*</span> Additive Manufacturing, Digital Manufacturing and
                  Industry 4.0</div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      s: 0.3,
      num: 0,
      len: 8,
      dateList: [
        {
          date: "February 15, 2024",
          text: "Deadline for abstract submission",
        },
        {
          date: "March 31, 2024",
          text: "Notification of abstract acceptance",
        },
        { date: "April 30, 2024", text: "Deadline for manuscript submission" },
        {
          date: "June 15, 2024",
          text: "Notification of manuscript acceptance",
          // acceptance
        },
        {
          date: "July 1, 2024",
          text: "Deadline for “early bird” registration",
        },
        { date: "October 1, 2024", text: "Final deadline for registration" },
      ],
      newsList: [
        { title: "1st IDS (IDS1978): ", text: "Montreal, Canada," },
        { title: "2nd IDS (IDS1980): ", text: "Montreal, Canada" },
        { title: "3rd IDS (IDS1982): ", text: "Birmingham, UK" },
        { title: "4th IDS (IDS1984): ", text: "Kyoto, Japan" },
        { title: "5th IDS (IDS1986): ", text: "Cambridge, USA" },
        { title: "6th IDS (IDS1988): ", text: "Versailles, France" },
        { title: "7th IDS (IDS1990): ", text: "Prague, Czechoslovakia" },

        { title: "8th IDS (IDS1992): ", text: "Montreal, Canada" },
        { title: "9th IDS (IDS1994): ", text: "Gold Coast, Australia" },
        { title: "10th IDS (IDS1996): ", text: "Krakow, Poland" },
        { title: "11th IDS (IDS1998): ", text: "Halkidiki, Greece" },
        {
          title: "12th IDS (IDS2000): ",
          text: "Noordwijkerhout, Netherlands",
        },
        { title: "13th IDS (IDS2002): ", text: "Beijing, China" },
        { title: "14th IDS (IDS2004): ", text: "Sao Paulo, Brazil" },

        { title: "15th IDS (IDS2006): ", text: "Budapest, Hungary" },
        { title: "16th IDS (IDS2008): ", text: "Hyderabad, India" },
        { title: "17th IDS (IDS2010): ", text: "Magdeburg, Germany" },
        { title: "18th IDS (IDS2012): ", text: "Xiamen, China" },
        { title: "19th IDS (IDS2014): ", text: "Lyon, France" },
        { title: "20th IDS (IDS2016): ", text: "Gifu, Japan" },
        { title: "21st IDS (IDS2018): ", text: "Valencia, Spain" },

        { title: "22nd IDS (IDS2020/2022): ", text: "Worcester, USA" },
        { title: "23rd IDS (IDS2024): ", text: "Wuxi, China" },
      ],
      username: "",
      password: "",
    };
  },
  onload() { },
  mounted() {
    console.log(
      window.localStorage.getItem("language"),
      "-==============444======"
    );
    var aa = this.newsList.length - this.len;
    setInterval(() => {
      this.num++;
      if (this.num > aa) {
        this.s = 0;
        this.num = 0;
      } else {
        this.s = 0.3;
      }
    }, 2000);
  },
  onShow() {
    console.log(
      window.localStorage.getItem("language"),
      "-===================="
    );
  },
  methods: {
    formatDate(str) {
      return str.replace(/(\d+)(th|st|nd|rd)/gi, '$1<sup>$2</sup>');
    },
    toCall(index) {
      if (index == 1) {
        this.$router.push("/newsDetail1");
      } else if (index == 2) {
        this.$router.push("/newsDetail");
      } else if (index == 3) {
        this.$router.push("/newsDetail3");
      } else if (index == 4) {
        this.$router.push("/newsDetail4");
      } else if (index == 5) {
        this.$router.push("/newsDetail5");
      } else if (index == 6) {
        this.$router.push("/newsDetail6");
      } else if (index == 7) {
        this.$router.push("/newsDetail7");
      } else if (index == 8) {
        this.$router.push("/program");
      } else if (index == 9) {
        this.$router.push("/newsDetail8");
      } else if (index == "newList") {
        this.$router.push("/newList");
      }
    },
    toRegFn() {
      this.$router.push("/simpleReg");
    },
    toDetail() {
      this.$router.push("/newsDetail");
    },
    toLoginThen() {
      if (!this.username) {
        this.$message.error(this.$t("indexmsgemail"));
        return;
      }
      if (!this.password) {
        this.$message.error(this.$t("indexmsgpwd"));
        return;
      }
      var params = {
        username: this.username,
        password: this.password,
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.login(params).then((res) => {
        console.log(res);
        loading.close();
        if (res.code == "200") {
          that.$message.success(that.$t("indexText26"));
          var con = res.data;
          localStorage.setItem("Firstname", con.Firstname);
          localStorage.setItem("Lastname", con.Lastname);
          localStorage.setItem("email", con.email);
          localStorage.setItem("mytitle", con.mytitle);
          localStorage.setItem("token", con.token);
          localStorage.setItem("visitor_id", con.visitor_id);
          setTimeout(() => {
            that.$router.push("/loginThen");
          }, 500);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.theme-title {
  display: flex;
  justify-content: space-between;
}

.theme-cons {
  position: relative;
  margin-top: 15px;
}

.theme-cons img {
  width: 100%;
}

.ff-text {
  position: absolute;
  left: 0;
  top: 10px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  z-index: 999;
  font-weight: 600;
  width: 100%;
}

/* .theme-title span{
  transform:skewX(45deg); 
} */

.block-green {
  width: 14px;
  height: 20px;
  background: #0a9a7a;
}

.contact-us {
  margin-top: 20px;
  color: #fff;
  padding-top: 20px;
  text-align: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.contact-title {
  font-size: 26px;
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.contact-con {
  width: auto;
  display: inline-block;
  margin: 0 auto;
  text-align: center;
}

.contact-text {
  text-align: center;
  margin: 10px auto;
}

.em-web {
  margin: 10px auto;
  justify-content: space-between;
  align-items: center;
  display: flex;
}

.em-web p {
  margin-bottom: 6px;
}

.em-web p:nth-of-type(1) {
  margin-right: 20px;
}

.mt-20 {
  margin-top: 50px;
}

/* :v-deep .el-carousel__container {
  min-height: 450px !important;
} */

.swiper,
.swiper-item {
  height: 536px;
}

.swiper-item {
  display: flex;
  align-items: center;
  justify-content: center;

}

.swiper-item p {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 24px;
}

.swiper-item-img {
  width: 100%;
  height: auto;
}

.index-con {
  width: 1200px;
  margin: 0 auto;
}

.index {
  width: 100%;
  padding-bottom: 40px;
}

.news-con {
  display: flex;
}

.news {
  width: 50%;
  background: #fff;
  padding-top: 20px;
}

.text-pink {
  font-weight: 600;
  margin-top: 10px;
  text-align: left;
  margin-bottom: 10px;
  color: #dc17d2;
  font-size: 12px;
}

.news-list-2 {
  flex: 1;
  padding-right: 15px;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.news-list-2:nth-of-type(3) {
  margin: 0;
}

.news-list-1 {
  /* width: 300px; */
  width: 100%;
}

.news-con .news:nth-of-type(2) {
  background: #f3f3f3;
}

.bg-green {
  background: #0a9a7a !important;
}

.sb-title {
  display: flex;
  /* justify-content: space-between; */
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px;
  height: 40px;
  box-sizing: border-box;
}

.sb-title p {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
}

.sb-title img {
  height: 30px;
}

.dsb {
  height: 45px;
}

.dsb img {
  height: 35px;
}

.dsb img:nth-of-type(1) {
  /* margin-left: 30px; */
}

.dsb img:nth-of-type(2) {
  margin-right: 30px;
}

.news-title {
  background: #055dae;
  color: #fff;
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: 600;
  padding-left: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.news-title img {
  height: 32px;
  margin-right: 4px;
}

.news-title1 {
  background: #055dae;
  color: #fff;
  height: 70px;
  line-height: 70px;
  font-size: 16px;
  font-weight: 600;
  padding-left: 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.news-title1 img {
  height: 32px;
  margin-right: 4px;
}

.bg-blue {
  background: rgb(9, 185, 218);
}

.pl-20 {
  font-size: 14px;
  text-indent: 15px;
}

.news-title i {
  font-size: 18px;
  margin-right: 4px;
}

.news-text {
  font-size: 14px;
  color: #444;
  padding: 5px 0;
  box-sizing: border-box;
  text-indent: 2em;
  line-height: 1.8;
  margin-bottom: 10px;
  text-align: justify;
}

.news-tips {
  background: #d80051;
  color: #fff;
  border-radius: 4px;
  margin: 5px 0;
  line-height: 1.8;
  padding: 5px 0;
  text-align: center;
}

.bg-green {
  background: #06b03e;
}

.news-btn {
  height: 55px;
  line-height: 55px;
  color: #fff;
  align-items: center;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 10px;
  background-image: url("https://img2.baidu.com/it/u=771525155,3661300380&fm=253&fmt=auto&app=138&f=JPEG?w=800&h=500");
}

.news-btn>i {
  font-size: 24px;
  flex-shrink: 0;
  color: rgba(255, 255, 255, 0.6);
}

.news-btn p {
  flex: 1;
  font-size: 16px;
  white-space: nowrap;
  padding-left: 10px;
}

.news-btn span {
  width: 30px;
  border-radius: 50%;
  height: 30px;
  flex-shrink: 0;
  border: 3px solid rgba(255, 255, 255, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-btn span i {
  font-size: 20px;
}

.news-pic {
  width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.news-paper-title {
  font-weight: 600;
}

.news-pic img {
  width: 100%;
}

.icon-span {
  width: 20px;
  border-radius: 50%;
  height: 20px;
  border: 2px solid #999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-span i {
  font-size: 16px;
  color: #999;
  font-weight: 700;
}

.new-list {
  display: flex;
  height: 30px;
  margin-bottom: 5px;
  font-size: 12px;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
}

.new-list p {
  padding-left: 17px;
  line-height: 1.3;
  position: relative;
}

.new-list p i {
  position: absolute;
  left: 0;
  top: 4px;
}

.new-list .icon-span {
  flex-shrink: 0;
}

.new-list b,
.new-list span {
  font-size: 12px;
}

.my-news-lists {
  overflow: hidden;
}

/* .my-news-list {
  transition: 0.3s all;
  height: 1300px;
} */

.new-tip-new {
  width: 40px;
  text-align: center;
  display: inline-block;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  background: #8198f4;
  color: #fff;
  border-radius: 4px;
  /* margin-left: 6px; */
  transform: scale(0.75);
}

.my-news-list .new-list {
  height: 25px;
  font-size: 12px;
  cursor: auto;
}

.new-list .el-icon-arrow-right {
  color: #777;
}

.login-con {
  padding: 15px;
  box-sizing: border-box;
  border: 1px solid #0a9a7a;
  box-sizing: border-box;
  color: #fff;
  /* background: #465b9f; */
}

.login-title {
  font-size: 18px;
  margin-bottom: 10px;
}

.login-title i {
  font-size: 20px;
}

.login-cons {
  padding: 0 20px;
  box-sizing: border-box;
}

.login-cons input {
  width: 100%;
  height: 40px;
  margin-bottom: 15px;
  padding-left: 10px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.1);
  line-height: 40px;
  border: 1px solid #fff;
}

.login-cons input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.login-btn {
  width: 100%;
  height: 40px;
  margin-bottom: 15px;
  padding-left: 10px;
  box-sizing: border-box;
  text-align: center;
  background: #af3f35;
  line-height: 40px;
}

.login-text {
  line-height: 1.9;
  color: #fff;
  cursor: not-allowed;
  cursor: no-drop;
  transition: 0.3s all;
}

.login-text:hover {
  color: #fff;
}

.login-lists {
  margin-top: 15px;
  background: #f3f3f3;
  color: #222;
  padding: 5px 10px;
  box-sizing: border-box;
}

.measurement-con {
  /* display: flex;
  flex-wrap: wrap; */
}

.measurement-con>div {
  /* width: 50%; */
  margin-bottom: 20px;
}

.imp-title {
  position: relative;
  text-align: center;
}

.imp-title>p {
  position: absolute;
  top: 20px;
  width: 100%;
  height: 100%;
  color: #fff;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
}

.imp-title img {
  width: 100%;
}

.one-bg-gray {
  height: 220px;
  padding: 15px 15px 15px;
  margin-top: -4px;
  position: relative;
  box-shadow: border-box;
}

.news-list-2 .news-cons {
  height: calc(100% - 50px);
  background-color: #f3f3f3;
  padding: 15px;
  box-sizing: border-box;
}

.two-bg-gray {
  font-size: 16px;
  height: 170px;
  padding: 15px;
  margin-top: 0;
  font-weight: 600;
  text-align: center;
  box-shadow: border-box;
}

.login-d-flex {
  display: flex;
}

.login-list {
  line-height: 1.8;
  /* color: #fff; */
}

.one-bg-gray .login-list {
  line-height: 2;
  white-space: nowrap;
  word-break: keep-all;
}

.measure-list {
  position: relative;
  padding-left: 10px;
  box-sizing: border-box;
}

.measure-list span {
  position: absolute;
  left: 0;
  top: 3px;
}

.login-list b {
  margin-right: 8px;
  flex-shrink: 0;
}

.login-list .text-justify {
  flex: 1;
  white-space: nowrap;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.login-list .text-justify ::v-deep(sup) {
  font-size: 0.7em;
  vertical-align: super;
  line-height: 0;
}

.mb-4 {
  margin-bottom: 4px;
}

.people {
  margin-top: 15px;
}

.people-title {
  background: #b34e16;
  color: #fff;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
  align-items: center;
  display: flex;
  padding-left: 15px;
}

.people-title i {
  margin-right: 8px;
  font-size: 18px;
}

.people-lists {
  display: flex;
  padding: 15px 10px 25px;
  box-sizing: border-box;
}

.h-350 {
  height: 350px;
}

.people-list {
  width: calc(20% - 10px);
  margin-right: 5px;
}

.people-pic {
  width: 110px;
  height: 150px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #ccc;
  background: #ddd;
  margin: 0 auto;
  border-radius: 4px;
}

.people-pic img {
  width: auto;
  height: 100%;
}

.people-title {
  font-weight: 600;
  text-align: center;
}

.peoples-title {
  text-align: center;
  padding-top: 6px;
  font-size: 12px;
}

.people-text {
  box-sizing: border-box;
  text-align: center;
  color: #666;
}

.text-999 {
  color: #999;
}

.bottom_span {
  padding-top: 80px;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.navbg {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
}

.text {
  color: #333;
  text-indent: 2em;
  line-height: 2;
  padding-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .swiper-item {
    align-items: start;
    height: 190px;
  }

  .swiper-item p {
    font-size: 12px;
  }

  .swiper {
    height: 190px;
    min-height: 150px;
    overflow: hidden;
  }

  .el-carousel__container {
    height: 190px;
  }

  .news {
    display: block;
  }

  .news-con {
    display: block;
  }

  .news-con .news {
    width: 100%;
  }


  .news-list-2 {
    width: calc(100% - 20px);
    margin: 0 auto;
    padding-right: 0;
  }

  .news-list-2:nth-of-type(3) {
    margin: 0 auto;
  }

  .news-con .news:nth-of-type(2) {
    width: calc(100% - 20px);
    margin: 0 auto;
  }

  .news-list-1 {
    width: 100%;
  }

  .people-lists {
    flex-wrap: wrap;
  }

  .people-list {
    width: calc(50% - 15px);
  }

  .news.mt-20 {
    margin-top: 10px;
  }

  .people-lists,
  .people-lists-contents {
    height: 740px;
  }

  .em-web {
    display: block;
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue